import {Button, makeStyles} from "@material-ui/core";
import {Description} from "@material-ui/icons";
import { CsvBuilder } from 'filefy';


const useStyles = makeStyles((theme) => ({
    button: {
        margin: theme.spacing(1),
    },
}))

export default function ExelExportBtn({data}) {
    const classes = useStyles();

    // console.log(data)

    const handleExport = ()=>{

        let rows = []
        for (let index = 0; index < data.length; index++) {
            let row=data[index];
            rows.push([
                row['id'],
                row['Categorie'],
                row['InternalId'],
                row['Barcode'],
                row['Name'],
                row['Price'],
                row['IsProductValidated'],
            ])
        }

        // console.log(rows);

        const builder = new CsvBuilder('filename.csv');

        builder
            .setDelimeter(',')
            .setColumns(['Id', 'Categorie', 'InternalId', 'Barcode', 'Name', 'Price', 'Status' ])
            .addRows(rows)
            .exportFile();

    }

    return (
        <Button
            variant="outlined"
            color="primary"
            size="small"
            className={classes.button}
            startIcon={<Description />}
            onClick={handleExport}
        >
            Exporter vers Exel
        </Button>
    )
}